if (!customElements.get('custom-featured-products')) {
  class CustomFeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this._swiperContainer = null;
      this._swiperInstance = null;
      this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 4);
    }

    connectedCallback() {
      // requestAnimationFrame(() => {
      //   this._swiperContainer = this.querySelector('.swiper');
      //   this.initializeSwiper();
      // });

       window.addEventListener('DOMContentLoaded', () => {
        this.observeElement(this, this.handleInViewport.bind(this));
      });
    }
    handleInViewport() {
      requestAnimationFrame(() => {
        this._swiperContainer = this.querySelector('.swiper');
        this.initializeSwiper();
      });
    }
    observeElement(element, callback) {
      // 创建一个 IntersectionObserver 实例
      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            callback();
            // 只执行一次，停止观察
            observerInstance.unobserve(entry.target);
          }
        });
      }, {
        // 视口外 1/2 高度以内触发
        root: null,
        threshold: 0.5
      });
      // 如果已经在视口内,立即执行回调
      if (this.isElementInViewport(element)) {
        callback();
        return;
      }
      observer.observe(element);
    }

    // 判断元素是否在视口内
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= -el.offsetHeight / 2 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
      );
    }
    initializeSwiper() {
      if (!this._swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      const nextButton = this.querySelector('.custom-featured-products__navigation .swiper-btn-next');
      const prevButton = this.querySelector('.custom-featured-products__navigation .swiper-btn-prev');
      const pagination = this.querySelector(`.custom-featured-products__pagination .swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerGroup: 1,
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: false,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          300: {
            slidesPerGroup: 1,
            slidesPerView: 1.3,
            spaceBetween: 16,
          },
          350: {
            slidesPerGroup: 1,
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
          375: {
            slidesPerGroup: 1,
            slidesPerView: 1.6,
            spaceBetween: 16,
          },
          590: {
            slidesPerGroup: 1,
            slidesPerView: 2.4,
            spaceBetween: 16,
          },
          769: {
            slidesPerGroup: 1,
            slidesPerView: 2.3,
            spaceBetween: 16,
          },
          990: {
            slidesPerGroup: this.columnsDesktop,
            slidesPerView: this.columnsDesktop,
            spaceBetween: 16,
          },
        }
      });
    }
  }

  customElements.define('custom-featured-products', CustomFeaturedProducts);
}